import React from "react";
import InnerHero from "../components/InnerHero";
import MapSection from "../components/MapSection";


function Contact() {
  return (
    <>
      <InnerHero
        title="Contact Us"
        subtitle="We’re here to support farmers, distributors, and partners. Reach out to us for product information, business enquiries, or support."
        breadcrumb="Home"
        bgImage="/images/img/23.png"
      />
      {/* <InnerHero
        title="Contact Us"
        subtitle="We’re here to support farmers, distributors, and partners."
        breadcrumb="Home"
        bgImage="/images/img/23.png"
        showCTA={true}
      /> */}

      <section className="contact-info-section">
        <div className="container">
          <div className="text-center mb-5">
            <h6 className="section-subtitle">GET IN TOUCH</h6>
            <h2 className="section-title">
              We’d Love to <span>Hear from You</span>
            </h2>
            <p className="section-desc">
              Reach out to us for product enquiries, distributor opportunities,
              or any support related to our agricultural solutions.
            </p>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="contact-card">
                <div className="contact-icon">📞</div>
                <h4>Call Us</h4>
                <p>Have a question? Talk to our support team.</p>
                <a href="tel:+918815529978">+91 88155 29978</a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="contact-card">
                <div className="contact-icon">📧</div>
                <h4>Email Us</h4>
                <p>Send us your enquiry and we’ll respond quickly.</p>
                <a href="mailto:Goodweelcropcare@gmail.com">
                  Goodweelcropcare@gmail.com
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 mb-4">
              <div className="contact-card">
                <div className="contact-icon">📍</div>
                <h4>Visit Us</h4>
                <p>Head Office & Factory</p>
                <span>
                  Gaurav Industrial Area,<br />
                  Rajkot, Gujarat – 360024
                </span>
              </div>
            </div>

          </div>

        </div>
      </section>
      <MapSection />

    </>
  );
}
export default Contact;
